
export default class UrlInfo {
    /**
     * @param {string} url 
     */
    constructor(url) {
        this.fullUrl = url;
        this.protocol = "";
        this.host = "";
        this.pathname = "";
        this.search = "";
        this.isValidUrl = validUrl(url);
        this.isAbsoluteUrl = this.isValidUrl && validAbsoluteUrl(url);
        this.isRelativeUrl = this.isValidUrl && !this.isAbsoluteUrl;
        
        if (this.isAbsoluteUrl) {
            var absoluteUrl = new URL(url);
            this.protocol = absoluteUrl.protocol;
            this.host = absoluteUrl.host;
            this.pathname = absoluteUrl.pathname;
            this.search = absoluteUrl.search;
        }
    
        if (this.isRelativeUrl) {
            this.pathname = url.split("?")[0];
            this.search = url.replace(this.pathname, "");
        }

        /**
         * @param {UrlInfo} urlInfoNextPage 
         * @returns {boolean}
         */
        this.goesToSameSite = function() {
            let urlInfoCurrentPage = new UrlInfo(window.location.href);
            let sameProtocol = this.isRelativeUrl || this.protocol == urlInfoCurrentPage.protocol;
            let sameHost = this.isRelativeUrl || this.host == urlInfoCurrentPage.host;

            let newPagePathNameSplit = this.pathname.split("/");
            let currentPagePathNameSplit = urlInfoCurrentPage.pathname.split("/");

            let samePage = (newPagePathNameSplit.length >= 2 && currentPagePathNameSplit.length >= 2)
            ? newPagePathNameSplit[1] == currentPagePathNameSplit[1]
            : false;

            if (samePage && newPagePathNameSplit[1].toLowerCase() === "en") {
                samePage = (newPagePathNameSplit.length >= 3 && currentPagePathNameSplit.length >= 3)
                ? newPagePathNameSplit[2] == currentPagePathNameSplit[2]
                : false;
            }

            return sameProtocol && sameHost && samePage;
        }

        /**
         * @param {UrlInfo} urlInfoNextPage 
         * @returns {boolean}
         */
        this.goesToCurrentUrl = function() {
            let urlInfoCurrentPage = new UrlInfo(window.location.href);
            let sameProtocol = this.isRelativeUrl || this.protocol == urlInfoCurrentPage.protocol;
            let sameHost = this.isRelativeUrl || this.host == urlInfoCurrentPage.host;
            let samePage = this.pathname == urlInfoCurrentPage.pathname;
            let sameSearch = this.search == urlInfoCurrentPage.search;
            return sameProtocol && sameHost && samePage && sameSearch;
        }

        this.goToPage = function() {
            window.location.assign(this.fullUrl);
        }
    }
};

/**
 * @param {string} url 
 * @returns {boolean}
 */
function validUrl(url) {
    if(!url) {
        return false;
    }

    if(validAbsoluteUrl(url)) {
        return true;
    }
    else {
        return url.startsWith("/") && !url.startsWith("//");
    }
}

/**
 * @param {string} url 
 * @returns {boolean}
 */
function validAbsoluteUrl(url) {
    try {
        new URL(url);
        return true;
    } catch (err) {
        return false;
    }
}